<template>
  <a
    v-if="isLogin"
    :href="`${consoleDomain}/${locale}`"
    target="_self"
    rel="noopener noreferrer"
    title="WISE-Console"
    class="rounded-full px-5 py-3 font-bold hover:bg-gray-600_a25 active:bg-gray-600_a35"
  >
    Console
  </a>
</template>

<script setup lang="ts">
  const { locale } = useI18n();
  const { consoleDomain } = useWebsite();

  const profileStore = useProfileStore();
  const { isLogin } = storeToRefs(profileStore);
</script>
